import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConfigService} from "../../services/config/config.service";

@Component({
  selector: 'app-forma-dosaggio',
  templateUrl: './forma-dosaggio.component.html',
  styleUrls: ['./forma-dosaggio.component.scss']
})
export class FormaDosaggioComponent {

  @Input() formaDosaggio: any = null

  @Output() navigate: EventEmitter<any> = new EventEmitter<any>();

  @Input() page: number=0;

  @Input() totalElements: number=0;

  @Input() size: number=10;
  constructor(private conf: ConfigService) {
  }

  isCarente(){
    return this.formaDosaggio.carente === 1
  }

  dettaglio(){
    this.navigate.emit(this.formaDosaggio)
    return false;
  }

  download(ts:any) {
    let url: string = `${this.conf.getConfig().baseUrl}organizzazione/${this.formaDosaggio.medicinale.codiceSis}/farmaci/${this.formaDosaggio.medicinale.aic6}/stampati?ts=${ts}`;
    window.open(url, '_blank')
  }

  paddingLeft(ts:number):string{
    return (ts+"").padStart(6,'0');
  }
}
